import { EventEmitter, Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VendorsService {

  public vendorProductObservable = new BehaviorSubject(null);
  public enrollmentChangedObservable = new BehaviorSubject(null);

  constructor(
    private restangular: Restangular
  ) {
  }

  getProductLaunchMetadata(vendorProductId): Promise<any> {
    return this.restangular.one('vendors', vendorProductId).one('launchmetadata').get().toPromise();
  }

  getCompany(vendorProductId): Promise<any> {
    return this.restangular.one('vendors', vendorProductId).one('getcompany').get().toPromise();
  }

  getEnrollment(vendorProductId): Promise<any> {
    return this.restangular.one('vendors', vendorProductId).one('getenrollment').get().toPromise();
  }

  getProductState(vendorProductId): Promise<any> {
    return this.restangular.one('vendors', vendorProductId).one('productstate').get().toPromise();
  }

  getProductStates(): Promise<any> {
    return this.restangular.one('vendors', 'products').one('productstates').get().toPromise();
  }

  getProductLaunchUrl(vendor, product, context): Promise<any> {
    return this.restangular.one('vendors', vendor).one('launchurl', product || 'no_product').customPUT(context || 'no_context').toPromise();
  }

  enrollProduct(vendor, product, context): Promise<any> {
    return this.restangular.one('vendors', vendor).one('enroll', product || 'no_product').customPUT(context || 'no_context').toPromise().then(result => {
      this.enrollmentChangedObservable.next({ vendor, product, context, result });
      return result;
    });
  }

  changePlanForProduct = function (oldVendorProduct, newVendorProduct) {
    return this.restangular.one('vendors', oldVendorProduct).one('changeplan', newVendorProduct).customPUT().toPromise();
  };

  updateProduct(vendor, product, context): Promise<any> {
    return this.restangular.one('vendors', vendor).one('update', product || 'no_product').customPUT(context || 'no_context').toPromise().then(result => {
      this.enrollmentChangedObservable.next({ vendor, product, context, result });
      return result;
    });
  }

  cancelProductEnrollment(vendor, product, context): Promise<any> {
    return this.restangular.one('vendors', vendor).one('unenroll', product || 'no_product').customPUT(context || 'no_context').toPromise().then(result => {
      this.enrollmentChangedObservable.next({ vendor, product, context, result });
      return result;
    });
  }

  getVendorProduct(vendorProductId: string): Promise<any> {
    if (!vendorProductId) {
      return Promise.resolve(null);
    }
    return this.restangular.one('vendors').one('product', vendorProductId).get().toPromise().then(result => {
      this.vendorProductObservable.next(result);
      return result;
    });
  }

  getCompanyAndStateForProduct(vendorProductId): Promise<any> {
    return this.restangular.one('vendors', 'groups').one('products/state', vendorProductId).get().toPromise();
  }

  getAllVendorProducts(): Promise<any> {
    return this.restangular.one('vendors').one('products', 'all').get().toPromise();
  }

  getVendorProductsWithUpdate(): Promise<any> {
    return this.restangular.one('vendors').one('products', 'updates').get().toPromise();
  }

  getVendorProductGroup(vendorProductId: string): Promise<any> {
    return this.restangular.one('vendors', 'groups').one('product', vendorProductId).get().toPromise();
  }

  getVendorGroupProductForUser(vendorProductId: string): Promise<any> {
    return this.restangular.one('vendors/groups/products/company').one('one', vendorProductId).getList().toPromise();
  }

  getProductChoices(productId: string): Promise<any> {
    return this.restangular.one('vendors/groups/products', productId).one('company', 'all').get().toPromise();
  }

  getVendorGroupPlan(planId: string): Promise<any> {
    return this.restangular.one('vendors/groups/plans/plan', planId).get().toPromise();
  }

}
